import NotFound from '../../../en/admin/exception/404/not_found'
import { withLang, withUserInfo } from 'component/HOC'
import { DEFAULT_EMPLOYEE } from 'util/constants'
import Loading from '../Loading/index'

const authorize = userInfo => {
  const { isDefault } = userInfo

  if (isDefault === DEFAULT_EMPLOYEE) {
    return 'isDefault'
  }

  return 'employee'
}

const withAuthorization = allowedRoles => WrappedComponent => (
  withUserInfo(props => {
    const { userInfo } = props
    if (!userInfo || !userInfo.isDefault) return <Loading />

    if (allowedRoles.includes(authorize(props.userInfo))) {
      return <WrappedComponent {...props} />
    }
    return withLang(<NotFound />)
  })
)

export const withDefaultEmployeeAuthorization = withAuthorization(['isDefault'])

export default withAuthorization
